const PIXEL_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID || "DAPP6GRC77U5PB605HTG";

// Plan values (USD) for InitiateCheckout / CompletePayment attribution
const PLAN_VALUES = {
  premium_monthly: 9.99,
  premium_annual: 49.99,
};

// Stripe price IDs -> plan IDs (mirrors STRIPE_PRODUCTS in services/subscription.js)
const STRIPE_PRICE_TO_PLAN = {
  price_1TGuUXLEwMxFpWxPrjY2OZMd: "premium_monthly",
  price_1TRsX0LEwMxFpWxPz9lWy2XG: "premium_monthly",
  price_1SVmpZLEwMxFpWxPy5ZeYoyy: "premium_monthly",
  price_1TGuhnLEwMxFpWxPiKl5fWUm: "premium_annual",
  price_1UIHHfLEwMxFpWxPkT9Y7dO3: "premium_annual",
};

let initialized = false;

export const initTikTokPixel = () => {
  if (initialized || !PIXEL_ID || typeof window === "undefined") return;
  initialized = true;

  const ttq = (window.TiktokAnalyticsObject = "ttq");
  const queue = (window.ttq = window.ttq || []);
  queue.methods = [
    "page",
    "track",
    "identify",
    "instances",
    "debug",
    "on",
    "off",
    "once",
    "ready",
    "alias",
    "group",
    "enableCookie",
    "disableCookie",
    "holdConsent",
    "revokeConsent",
    "grantConsent",
  ];
  queue.setAndDefer = function (t, e) {
    t[e] = function () {
      t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
    };
  };
  for (let i = 0; i < queue.methods.length; i++) {
    queue.setAndDefer(queue, queue.methods[i]);
  }
  queue.instance = function (t) {
    const e = queue._i[t] || [];
    for (let n = 0; n < queue.methods.length; n++) {
      queue.setAndDefer(e, queue.methods[n]);
    }
    return e;
  };
  queue.load = function (e, n) {
    const r = "https://analytics.tiktok.com/i18n/pixel/events.js";
    queue._i = queue._i || {};
    queue._i[e] = [];
    queue._i[e]._u = r;
    queue._t = queue._t || {};
    queue._t[e] = +new Date();
    queue._o = queue._o || {};
    queue._o[e] = n || {};
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = r + "?sdkid=" + e + "&lib=" + ttq;
    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);
  };

  queue.load(PIXEL_ID);
  queue.page();
};

export const trackTikTokPageView = () => {
  if (window.ttq) window.ttq.page();
};

export const trackTikTokEvent = (eventName, params = {}) => {
  if (window.ttq) window.ttq.track(eventName, params);
};

export const trackTikTokInitiateCheckout = (planId) => {
  const params = {
    contents: [
      {
        content_id: planId,
        content_name: planId,
        content_type: "product",
        quantity: 1,
        price: PLAN_VALUES[planId],
      },
    ],
    currency: "USD",
  };
  if (PLAN_VALUES[planId] !== undefined) {
    params.value = PLAN_VALUES[planId];
  }
  trackTikTokEvent("InitiateCheckout", params);
};

export const trackTikTokCompletePayment = (priceId, eventID) => {
  const planId = STRIPE_PRICE_TO_PLAN[priceId];
  const params = {
    contents: [
      {
        content_id: planId || "subscription",
        content_name: planId || "subscription",
        content_type: "product",
        quantity: 1,
        price: planId ? PLAN_VALUES[planId] : undefined,
      },
    ],
    currency: "USD",
  };
  if (planId) {
    params.value = PLAN_VALUES[planId];
  }
  if (eventID) {
    params.event_id = eventID;
  }
  trackTikTokEvent("CompletePayment", params);
};

export const trackTikTokCustomEvent = (eventName, params = {}) => {
  if (window.ttq) window.ttq.track(eventName, params);
};
